module.exports = __webpack_public_path__ + "img/icon_design_hover.954f2278.svg";